import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck, Clock } from "lucide-react";
import { COMPANY, NAV_LINKS, OFFICE_HOURS } from "../lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-blue-dark text-white pt-16 pb-8 mt-12"
    >
      <div className="container-pad grid gap-10 md:grid-cols-2 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-white rounded-xl p-1.5 shadow-md inline-flex items-center justify-center">
              <img
                src={COMPANY.logo}
                alt="1st Home Care logo"
                className="h-12 w-auto object-contain"
                style={{ mixBlendMode: "multiply" }}
              />
            </div>
            <div className="font-heading text-xl font-bold">1st Home Care</div>
          </div>
          <p className="text-white/75 text-sm leading-relaxed">
            Compassionate, licensed home care services across Springfield,
            Fairfax, and Northern Virginia. Care you can trust.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 bg-white/10 rounded-full px-3 py-1.5 text-xs font-semibold">
            <ShieldCheck className="w-3.5 h-3.5 text-brand-amber-light" />
            Licensed Virginia Home Care Organization
          </div>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold mb-4">Pages</h4>
          <ul className="space-y-2 text-sm text-white/80">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="hover:text-brand-amber-light transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold mb-4">Services</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li>Skilled Nursing</li>
            <li>Private Duty Nursing</li>
            <li>Personal Care</li>
            <li>Respite Care</li>
            <li>Medicaid &amp; Private Pay</li>
          </ul>
        </div>

        <div data-testid="footer-hours">
          <h4 className="font-heading text-base font-semibold mb-4 flex items-center gap-2">
            <Clock className="w-4 h-4 text-brand-amber-light" /> Office Hours
          </h4>
          <ul className="space-y-1.5 text-xs text-white/80">
            {OFFICE_HOURS.map((h) => (
              <li key={h.day} className="flex justify-between gap-3">
                <span className="font-semibold uppercase tracking-wider text-white/90 w-10">{h.day}</span>
                <span>{h.time}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/85">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 text-brand-amber-light shrink-0" />
              <span>{COMPANY.fullAddress}</span>
            </li>
            <li>
              <a
                href={`tel:${COMPANY.phoneTel}`}
                data-testid="footer-phone"
                className="flex items-center gap-2 hover:text-brand-amber-light"
              >
                <Phone className="w-4 h-4 text-brand-amber-light" />
                {COMPANY.phone}
              </a>
            </li>
            {COMPANY.emails.map((em) => (
              <li key={em}>
                <a
                  href={`mailto:${em}`}
                  data-testid={`footer-email-${em}`}
                  className="flex items-center gap-2 hover:text-brand-amber-light whitespace-nowrap"
                >
                  <Mail className="w-4 h-4 text-brand-amber-light shrink-0" />
                  <span className="truncate text-xs">{em}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="container-pad mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
        <div>
          © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
        </div>
        <div>Serving Fairfax • Prince William • Loudoun • Arlington Counties + Alexandria, Fairfax, Manassas, Manassas Park & Falls Church</div>
      </div>
    </footer>
  );
}
